import { getDiscountAuth } from '@/api/cashier'
const state = () => ({
  cashierStaffInfo: null,
})
const mutations = {
  SET_CASHIER_STAFF(state, cashierStaffInfo) {
    state.cashierStaffInfo = cashierStaffInfo
  },
}

const actions = {
  /**
   * 当前登录员工信息
   * @param {*} payload
   * @returns
   */
  async FETCH_CASHIER_STAFF({ commit, state }, payload) {
    // 如果存在则不再发起请求
    if (!payload.needRefresh && state.cashierStaffInfo) return { data: state.cashierStaffInfo }
    // 发起 http 请求
    const { data } = await getDiscountAuth()
    // mutation
    commit(`SET_CASHIER_STAFF`, data)
    return { data }
  },
  setCashierStaff({ commit }, cashierStaffInfo) {
    commit(`SET_CASHIER_STAFF`, cashierStaffInfo)
  },
}

export default { state, mutations, actions }
